import { useMemo, useState } from 'react';
import { IPreferences } from 'shared/interfaces/ITalent';
import { talentService } from 'shared/services/talentService';
import { setUser } from 'shared/redux/slicers/user.slicer';
import { useAppSelector } from 'shared/redux/store';
import { useDispatch } from 'react-redux';

export type ViewModeProps = 'list' | 'grid';

export type UseViewModeProps = {
  type: 'cars' | 'pets' | 'asset_props';
  preferences: IPreferences | null;
};

const { updateMe } = talentService();

export const useViewMode = ({ type, preferences }: UseViewModeProps) => {
  const { mutate: updateMutate } = updateMe();
  const dispatch = useDispatch();
  const { user: userState } = useAppSelector((state) => state);
  const [loading, setLoading] = useState(false);
  const view = useMemo(() => {
    const defaultView = 'list';
    const prefView = preferences?.my_info?.[type]?.view;

    return prefView || defaultView;
  }, [type, preferences]);

  const handleView = async (value: ViewModeProps) => {
    if (value !== view) {
      setLoading(true);

      updateMutate(
        {
          preferences: {
            ...preferences,
            my_info: {
              ...preferences?.my_info,
              [type]: { view: value },
            },
          },
        },
        {
          onSuccess: async () => {
            dispatch(
              setUser({
                user: {
                  ...userState.user,
                  attributes: {
                    ...userState.user?.attributes,
                    preferences: {
                      ...preferences,
                      my_info: {
                        ...preferences?.my_info,
                        [type]: { view: value },
                      },
                    },
                  },
                },
              }),
            );
            setLoading(false);
          },
          onError: async () => {
            setLoading(false);
          },
        },
      );
    }
  };

  return { view, handleView, viewModeLoading: loading };
};
